import { Components, Theme } from '@mui/material/styles';

export const typographyConfigs: Components<Theme>['MuiTypography'] = {
  defaultProps: {
    component: 'div',
    variant: 'body1',
  },
  styleOverrides: {
    h2: ({ theme }) => ({
      color: theme.palette.neutral[1000],
    }),
    h3: ({ theme }) => ({
      color: theme.palette.neutral[1000],
    }),
    body1: ({ theme }) => ({
      color: theme.palette.neutral[800],
    }),
  },
};
